import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Button, Select } from '../../../components';

const DURATION_OPTIONS = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];

export default class ApplyTemplateModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool,
		onClose: PropTypes.func.isRequired,
		templateOptions: PropTypes.array,
		onApplyTemplate: PropTypes.func,
		defaultDuration: PropTypes.number.isRequired
	}

	state = {
		selectedDuration: 20, // default
		selectedTemplateId: 0
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.isOpen && !this.props.isOpen) {
			this.setState({
				selectedDuration: this.props.defaultDuration,
				selectedTemplateId: 0
			});
		}
	}

	handleTemplateChosen = ({ target }) => {
		this.setState({ selectedTemplateId: target.value });
	}

	handleDurationChosen = ({ target }) => {
		this.setState({ selectedDuration: target.value });
	}

	handleApplyTemplate = () => {
		this.props.onApplyTemplate({
			templateId: this.state.selectedTemplateId,
			duration: this.state.selectedDuration
		});
	}

	render() {
		const {
			isOpen = false,
			onClose,
			templateOptions = [],
		} = this.props;

		const { selectedTemplateId, selectedDuration } = this.state;

		return (
			<Modal
				isOpen={isOpen}
				onRequestClose={onClose}
				className="modal-dialog"
			>
				<div className="modal-content">
					<div className="modal-header">
						<button type="button" data-dismiss="modal" aria-label="Close" className="close" onClick={onClose}>
							<span aria-hidden="true">×</span>
						</button>
						<h4 className="modal-title">Apply Template</h4>
					</div>
					<div className="modal-body">
						<Select
							label="Template"
							options={templateOptions}
							onChange={this.handleTemplateChosen}
							selectedValue={selectedTemplateId}
						/>
						<Select
							label="Slot Duration (in minutes)"
							options={DURATION_OPTIONS}
							onChange={this.handleDurationChosen}
							selectedValue={selectedDuration}
						/>
					</div>
					<div className="modal-footer">
						<Button title="Cancel" onClick={onClose} />
						<Button title="Save" onClick={this.handleApplyTemplate} primary />
					</div>
				</div>
			</Modal>
		);
	}
}
